import React from "react";
import { Card, Typography } from "antd";

const { Title, Paragraph } = Typography;

const HelpSupport = () => {
  return (
    <div className="mainContain">
      <Title level={3}>Help & Support</Title>

      <Card className="mb-3">
        <Title level={4}>💡 How can we help you?</Title>
        <Paragraph>
          If you're facing issues with transactions, complaints, or login
          problems — you can reach out directly to our support team.
        </Paragraph>
      </Card>

      <Card className="mb-3">
        <Title level={4}>📞 Contact Information</Title>
        <Paragraph>
          Email:{" "}
          <a href="mailto:agent.support@plutos.one">agent.support@plutos.one</a>
        </Paragraph>
      </Card>

      {/* <Card>
        <Title level={4}>📚 FAQ</Title>
        <Paragraph>
          <b>Q:</b> How to raise a complaint?
          <br />
          <b>A:</b> Go to the Complaints tab and click "New Complaint".
        </Paragraph>
        <Paragraph>
          <b>Q:</b> What if my complaint is not resolved?
          <br />
          <b>A:</b> Contact support with your Complaint ID.
        </Paragraph>
      </Card> */}
    </div>
  );
};

export default HelpSupport;
